import { Outlet, useNavigation } from "react-router-dom"
import MenuAppBar from "../components/MenuAppBar";
import { Box, CircularProgress, Container } from "@mui/material";
import { useClearAppBoxContent } from "../components/AppBarBox";
import useOnRouteChange from "../hooks/useOnRouteChange";

const scrollToTop = () => {
  window.scrollTo(0, 0)
}

export const Element: React.FC = () => {
  const navigation = useNavigation()

  useOnRouteChange(useClearAppBoxContent())
  useOnRouteChange(scrollToTop)

  return <>
    <MenuAppBar />
    {navigation.state === "loading"
      ? (
        <Container component="main">
          <Box
            sx={{
              marginTop: 8,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <CircularProgress color="inherit" />
          </Box>
        </Container>
      )
      : (
        <Outlet />
      )}
  </>
}

export default Element
